import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "login-page",
  class: "relative mx-auto h-full w-full max-w-screen-md p-8 md:p-0"
}
const _hoisted_2 = { class: "pt-32 mx-auto max-w-sm" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col w-full pt-2 red--text text-overline"
}
const _hoisted_4 = { id: "office-dialog" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col w-full pt-2 red--text text-overline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_form, {
        ref: "form",
        class: "elevation-6 p-4 rounded-md white",
        "lazy-validation": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            autocomplete: "false",
            class: "mb-2",
            label: "E-mail",
            required: "",
            variant: "outlined",
            rules: _ctx.emailRules,
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errors = []))
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
            autocomplete: "false",
            class: "mb-4",
            label: "Password",
            required: "",
            variant: "outlined",
            rules: _ctx.passwordRules,
            type: "password",
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors = []))
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_v_btn, {
            disabled: !_ctx.email || !_ctx.password,
            color: "primary",
            class: "mr-2",
            onClick: _ctx.handleLogin
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Login ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_router_link, {
            to: { path: '/forgot-password', query: { email: this.email }},
            tag: "button",
            class: "font-medium text-blue-600 dark:text-blue-500 hover:underline"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Forgot Password? ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]),
          (_ctx.errors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-xs",
                    key: index
                  }, _toDisplayString(error), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    (_ctx.user && _ctx.user.uuid)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.dialog,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog) = $event)),
          "max-width": "400",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.office,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.office) = $event)),
                  _ctx.handleSelectOffice
                ],
                items: _ctx.user.offices.filter(o => o.name !== 'Zagreb Office'),
                hint: "Please select a practice.",
                "item-title": "name",
                "item-value": "id",
                label: "Practice",
                "persistent-hint": "",
                "return-object": "",
                variant: "solo",
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors = []))
              }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
              (_ctx.errors)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mt-xs mb-xs",
                        key: index
                      }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}